import { DashboardDeviceType } from '@akin-home/amplify';
import { DashboardModel } from '../types';

export const findDashboardByDeviceType =
  (device_type: DashboardDeviceType) => (dashboards?: DashboardModel[]) => {
    return dashboards?.find(
      (dashboard) => dashboard.device_type === device_type
    );
  };

export const findTabletDashboard = findDashboardByDeviceType(
  DashboardDeviceType.tablet
);

export const findMobileDashboard = findDashboardByDeviceType(
  DashboardDeviceType.mobile
);
